module.exports = __webpack_public_path__ + "static/img/7.3a61dd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/eng/7.png
// module id = tvO8
// module chunks = 0